"use client";

import { Input } from "@/components/ui/Input";

export type ItemRow = { productLabel: string; price: string; unit: "kg" | "adet" | "demet" | "bag" };
const UNITS: { v: ItemRow["unit"]; l: string }[] = [{ v: "kg", l: "kg" }, { v: "adet", l: "adet" }, { v: "demet", l: "demet" }, { v: "bag", l: "bağ" }];
const MAX = 20;

/** Ürün / fiyat / birim satırları; ürün adı önerili serbest metin (editör ürünle eşler). */
export default function BazaarItemRows({ rows, onChange, products }: { rows: ItemRow[]; onChange: (r: ItemRow[]) => void; products: string[] }) {
  const set = (i: number, patch: Partial<ItemRow>) => onChange(rows.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  return (
    <fieldset className="space-y-3">
      <legend className="text-label font-semibold">Fiyatlar *</legend>
      <datalist id="bazaar-products">{products.map((p) => <option key={p} value={p} />)}</datalist>
      {rows.map((r, i) => (
        <div key={i} className="grid grid-cols-[minmax(0,1fr)_7rem_6rem_auto] items-center gap-2">
          <Input aria-label={`${i + 1}. ürün`} list="bazaar-products" value={r.productLabel} maxLength={80} placeholder="Ürün (ör. Domates)" onChange={(e) => set(i, { productLabel: e.target.value })} />
          <Input aria-label={`${i + 1}. fiyat (TL)`} inputMode="decimal" value={r.price} placeholder="TL" onChange={(e) => set(i, { price: e.target.value.replace(/[^\d.,]/g, "") })} />
          <select aria-label={`${i + 1}. birim`} value={r.unit} onChange={(e) => set(i, { unit: e.target.value as ItemRow["unit"] })} className="h-12 rounded-xl border border-(--color-border) bg-(--color-surface) px-2">
            {UNITS.map((u) => <option key={u.v} value={u.v}>{u.l}</option>)}
          </select>
          <button type="button" aria-label={`${i + 1}. satırı sil`} disabled={rows.length === 1} onClick={() => onChange(rows.filter((_, j) => j !== i))} className="min-h-11 min-w-11 rounded-lg border border-(--color-border) text-(--color-muted) disabled:opacity-40">×</button>
        </div>
      ))}
      {rows.length < MAX ? <button type="button" onClick={() => onChange([...rows, { productLabel: "", price: "", unit: "kg" }])} className="min-h-11 text-label font-semibold text-(--color-brand) underline">+ Ürün ekle</button> : null}
    </fieldset>
  );
}
